export const Endpoints = {
  DAIRY: '/dairies',
  LOCATIONS: '/offices',
  HUSBANDRY_FORMS: '/husbandry-forms',
  FARMERS: '/offices',
  FARMER_GROUPS: '/farmer-groups',
  BANKS: '/banks',
  STATES: '/states',
  DISTRICT: '/districts',
  MILK_TYPES: '/milk-types',
  BANK_ACCOUNTS: '/bank-accounts',
  MGA_FACTORS: '/mga-factors',
  MGA_FACTOR: '/mga-factor',
  MILK_BILLING: '/milk-billing',
  IFE_SETTINGS: '/ife-settings',
  UPDATE_LOGS: '/update-logs',
  ACTIVITY_LOGS: '/activity-logs',
  ACTIVITY_LOG_HISTORY: '/activity-log-histories',
  SETTINGS: '/settings',
  TRADING_SLOTS: '/trading-slots',
  TRADING_SLOTS_CREATE: '/trading-slots/create',
  NEWSLETTER: '/newsletter',
  CLOUD_STORAGE: '/cloud-storage',
  FAQ: '/faq'
};

